
import { ChildrenHeader } from "@/components/children/ChildrenHeader";
import { ChildrenList } from "@/components/children/ChildrenList";
import { ChildrenDialogs } from "@/components/children/ChildrenDialogs";
import { ChildrenLoadingState } from "@/components/children/ChildrenLoadingState";
import { useChildrenData } from "@/components/children/hooks/useChildrenData";

export function Children() {
  const {
    isLoading,
    children,
    addDialogOpen,
    setAddDialogOpen,
    editDialogOpen,
    setEditDialogOpen,
    deleteDialogOpen,
    setDeleteDialogOpen,
    selectedChild,
    handleAddChild,
    handleChildAdded,
    handleEditChild,
    handleChildUpdated,
    handleDeleteChild,
    handleConfirmDelete
  } = useChildrenData();

  if (isLoading) {
    return <ChildrenLoadingState />;
  }

  return (
    <div className="container mx-auto max-w-5xl p-4 md:p-6">
      <ChildrenHeader onAddChild={handleAddChild} />
      
      <ChildrenList 
        children={children} 
        onEdit={handleEditChild} 
        onDelete={handleDeleteChild}
        onAddChild={handleAddChild}
      />
      
      <ChildrenDialogs
        addDialogOpen={addDialogOpen}
        setAddDialogOpen={setAddDialogOpen}
        onChildAdded={handleChildAdded}
        
        editDialogOpen={editDialogOpen}
        setEditDialogOpen={setEditDialogOpen}
        selectedChild={selectedChild}
        onChildUpdated={handleChildUpdated}
        
        deleteDialogOpen={deleteDialogOpen}
        setDeleteDialogOpen={setDeleteDialogOpen}
        onConfirmDelete={handleConfirmDelete}
      />
    </div>
  );
}
